import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SoundService {
  private context: AudioContext | null = null;
  private unlocked = false;
  private initialized = false;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  public initialize(): void {
    if (!this.initialized) {
        this.initialized = true;
        const unlock = () => {
            if (this.unlocked) return;
            this.unlocked = true;
      
            if (!this.context) {
              this.context = new AudioContext();
            }
            if (this.context.state === 'suspended') {
              this.context.resume();
            }
          };
      
        this.document.addEventListener('pointerdown', unlock, { once: true, passive: true });
        this.document.addEventListener('keydown', unlock, { once: true, passive: true });
    }
  }

  hangup(): void {
    if (!this.context || this.context.state !== 'running') return;

    const now = this.context.currentTime;

    const notes = [520, 440, 360]; // Hz, descending short melody
    const noteDuration = 0.08; // 80ms per note
    const osc = this.context.createOscillator();
    const gain = this.context.createGain();

    osc.type = 'sine';
    osc.connect(gain);
    gain.connect(this.context.destination);

    gain.gain.setValueAtTime(0, now);

    notes.forEach((freq, i) => {
      const start = now + i * noteDuration;
      const end = start + noteDuration;

      osc.frequency.setValueAtTime(freq, start);

      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.15, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, end);
    });

    osc.start(now);
    osc.stop(now + notes.length * noteDuration);

    // const osc = this.context.createOscillator();
    // const gain = this.context.createGain();
  
    // const now = this.context.currentTime;
    // const duration = 0.5;
  
    // osc.type = 'sawtooth';
    // osc.frequency.setValueAtTime(400, now);
  
    // // softer UI volume + clean envelope
    // gain.gain.setValueAtTime(0, now);
    // gain.gain.linearRampToValueAtTime(0.2, now + 0.01);
    // gain.gain.exponentialRampToValueAtTime(0.001, now + duration);
  
    // osc.connect(gain);
    // gain.connect(this.context.destination);
  
    // osc.start(now);
    // osc.stop(now + duration);

    // const osc = this.context.createOscillator();
    // const gain = this.context.createGain();
    // const now = this.context.currentTime;

    // osc.type = 'sine';
    // osc.frequency.setValueAtTime(420, now);

    // gain.gain.setValueAtTime(0, now);
    // gain.gain.linearRampToValueAtTime(0.15, now + 0.01);
    // gain.gain.exponentialRampToValueAtTime(0.001, now + 0.12);

    // osc.connect(gain);
    // gain.connect(this.context.destination);

    // osc.start(now);
    // osc.stop(now + 0.13);
  }
}
